/**
 * TUVI - Formato PDF de una Actualización del proyecto, para firma del cliente.
 * Mismo estilo de los demás documentos (banner, datos, secciones beige, imagen final).
 * Usa las clases de Cotizaciones.css (adicional-page, pdf-*).
 */
import React from 'react';

const OBSERVACIONES = [
  'La presente actualización hace parte integral del contrato y de la cotización aprobada del proyecto.',
  'Las demás condiciones pactadas se mantienen sin modificación, salvo lo expresamente descrito en este documento.',
  'Con la firma de este documento el propietario declara conocer y aceptar a satisfacción el cambio aquí descrito.',
];

const fechaLarga = (d) => {
  if (!d) return '';
  try {
    return new Date(d.length === 10 ? d + 'T12:00:00' : d).toLocaleDateString('es-CO', { day: '2-digit', month: 'long', year: 'numeric' });
  } catch { return d; }
};

const ActualizacionPDF = ({ actualizacion, proyecto }) => {
  if (!actualizacion || !proyecto) return null;
  const p = proyecto;
  return (
    <div className="adicional-page">
      <div className="pdf-banner">
        <img src="/logo_tuvi_banner.jpg" alt="TUVI" className="pdf-banner-logo" crossOrigin="anonymous" />
        <span className="pdf-banner-title">ACTUALIZACIÓN</span>
      </div>

      <div style={{ padding: '65px 65px 0' }}>
        <div className="pdf-fecha-cotizacion">
          <span className="pdf-fecha-lbl">Actualización No. {actualizacion.consecutivo}</span>
          <span className="pdf-fecha-val">{fechaLarga(actualizacion.fecha)}</span>
        </div>

        <div className="pdf-datos-wrapper">
          <div className="pdf-datos-left">
            <table className="pdf-datos-block">
              <thead><tr><th colSpan="2" className="pdf-datos-title-dark">Datos del Propietario</th></tr></thead>
              <tbody>
                <tr><td className="pdf-dato-lbl">Nombre</td><td className="pdf-dato-val">{p.nombre_cliente}</td></tr>
                <tr><td className="pdf-dato-lbl">Cedula</td><td className="pdf-dato-val">{p.cedula || ''}</td></tr>
                <tr><td className="pdf-dato-lbl">Telefono</td><td className="pdf-dato-val">{p.telefono || ''}</td></tr>
                <tr><td className="pdf-dato-lbl">Correo</td><td className="pdf-dato-val">{p.correo || ''}</td></tr>
              </tbody>
            </table>
          </div>
          <div className="pdf-datos-right">
            <table className="pdf-datos-block">
              <thead><tr><th colSpan="4" className="pdf-datos-title-dark">Datos del Inmueble</th></tr></thead>
              <tbody>
                <tr><td className="pdf-dato-lbl">Proyecto</td><td colSpan="3" className="pdf-dato-val">{p.proyecto_nombre}</td></tr>
                <tr className="pdf-separator-row"><td colSpan="4"></td></tr>
                <tr>
                  <td className="pdf-dato-lbl">Apartamento</td><td className="pdf-dato-val">{p.apartamento || ''}</td>
                  <td className="pdf-dato-lbl">Area</td><td className="pdf-dato-val">{p.area_m2 ? `${p.area_m2} m²` : ''}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="cotizacion-pdf-section" style={{ marginTop: '18px' }}>
          <h4 className="pdf-section-beige">DETALLE DE LA ACTUALIZACIÓN</h4>
          <p style={{ fontSize: '10pt', fontWeight: 700, margin: '6px 10px 4px', color: '#123333' }}>{actualizacion.titulo}</p>
          <p style={{ fontSize: '9pt', margin: '0 10px 6px', whiteSpace: 'pre-wrap', textAlign: 'justify', lineHeight: 1.5 }}>{actualizacion.descripcion}</p>
          {actualizacion.imagen ? (
            <div style={{ margin: '10px 10px 4px', textAlign: 'center' }}>
              <img src={actualizacion.imagen} alt="Soporte" style={{ maxWidth: '100%', maxHeight: '420px', objectFit: 'contain', border: '1px solid #e5e0cf', borderRadius: '4px' }} />
              <p style={{ fontSize: '7pt', margin: '4px 0 0', color: '#888' }}>Soporte adjunto: {actualizacion.adjunto_nombre}</p>
            </div>
          ) : actualizacion.adjunto_nombre && (
            <p style={{ fontSize: '8pt', margin: '4px 10px 0', color: '#666' }}>Soporte adjunto: {actualizacion.adjunto_nombre}</p>
          )}
        </div>

        <div className="cotizacion-pdf-section pdf-section-small" style={{ marginTop: '12px' }}>
          <h4 className="pdf-section-beige">OBSERVACIONES</h4>
          <div className="pdf-observaciones">
            {OBSERVACIONES.map((o, i) => <p key={i}>&#8226; {o}</p>)}
          </div>
        </div>

        {/* Aceptación del cliente */}
        <div className="cotizacion-pdf-section pdf-aceptacion" style={{ marginTop: '14px' }}>
          <h4 className="pdf-section-beige">ACEPTACIÓN DEL CLIENTE</h4>
          <p className="pdf-aceptacion-texto">
            Declaro que conozco y acepto a satisfacción la actualización No. {actualizacion.consecutivo} descrita en este documento.
          </p>
          <div className="pdf-aceptacion-grid">
            <div className="pdf-aceptacion-firma">
              <div className="pdf-aceptacion-linea"></div>
              <span className="pdf-aceptacion-lbl">Firma del propietario</span>
            </div>
            <div className="pdf-aceptacion-datos">
              <div className="pdf-aceptacion-campo"><span className="pdf-aceptacion-lbl">Nombre</span><span className="pdf-aceptacion-val">{p.nombre_cliente}</span></div>
              <div className="pdf-aceptacion-campo"><span className="pdf-aceptacion-lbl">Cédula</span><span className="pdf-aceptacion-val">{p.cedula || ''}</span></div>
              <div className="pdf-aceptacion-campo"><span className="pdf-aceptacion-lbl">Fecha de aceptación</span><span className="pdf-aceptacion-val"></span></div>
            </div>
          </div>
        </div>
      </div>

      <div className="pdf-imagen-final">
        <img src="/final_cotizador.png" alt="TUVI" crossOrigin="anonymous" />
      </div>
    </div>
  );
};

export default ActualizacionPDF;
